import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';
import Describe from '../utils/lib/describe';

const COUPON_TYPE_LABEL = {
    1: '商家券',
    2: '通用券',
};
const COUPON_STATUS = {
    STATUS_NEW: 1,
    STATUS_RECEIVED: 2,
    STATUS_FAILED: 3,
    STATUS_USED: 4,
    STATUS_EXPIRED: 5,
    STATUS_LOCKED_NEW: 6,
    STATUS_RECEIVE_EXPIRED: 7,
};
const { createUniqueId } = common;

const operateBtnId = createUniqueId();
const btnIdBeforeRecv = createUniqueId();
const btnIdAfterRecv = createUniqueId();

const COMPONENT_ID = 'waimai_aa310cpq';
const SUB_COMPONENT_COUPON_ID = 'waimai_cqltoxck';
const SUB_COMPONENT_USE_ID = 'waimai_s0kvikg0';
const SUB_COMPONENT_RECEIVE_ALL_ID = 'waimai_dv4vi179';

const describeCouponListA = new Describe('CouponListA', COMPONENT_ID);
const describeCoupon = new Describe('Coupon', SUB_COMPONENT_COUPON_ID);
const describeReceiveAll = new Describe('ReceiveAll', SUB_COMPONENT_RECEIVE_ALL_ID);
const describeUse = new Describe('Use', SUB_COMPONENT_USE_ID);

describeCouponListA.setSubComponent('Coupon', describeCoupon);
describeCouponListA.setSubComponent('ReceiveAll', describeReceiveAll);
describeCouponListA.setSubComponent('Use', describeUse);
const CouponListA = (props) => {
    const { title = '', giftInfoList = [], ignoreCommonCoupon = false } = props || {};
    const { btnNameBeforeRecv = '一键领取', btnNameAfterRecv = '立即下单' } = props || {};
    const { onCouponClick, onBatchRecvClick, onBatchUseClick } = props || {};

    // 忽略显示通用红包
    if (ignoreCommonCoupon) {
        let index = -1;
        giftInfoList.some((item, i) => {
            if ( item.giftInfo && item.giftInfo.type === 2 ) { // 通用红包type为2
                index = i;
                return true;
            }
        });
        if (index > -1) {
            giftInfoList.splice(index, 1);
        }
    }

    // 过滤出未领取的红包
    const newCouponInfos = giftInfoList.filter(
        (item) => item.giftInfo && item.giftInfo.status === COUPON_STATUS.STATUS_NEW,
    );
    // 获取红包id集合
    const giftIds = newCouponInfos.map((item) => item.giftInfo.gift_id);

    const data = {
        title,
        giftInfoList,
        couponLabel: COUPON_TYPE_LABEL,
        operateBtnId,
        btnIdBeforeRecv,
        btnNameBeforeRecv,
        btnIdAfterRecv,
        btnNameAfterRecv,
        hasRecv: giftIds.length === 0,
    };
    const events = {
        handleCouponClick(index) {
            onCouponClick && onCouponClick(giftInfoList[index], index);
        },
        async handleBatchRecvClick() {
            if (onBatchRecvClick) {
                const result = await onBatchRecvClick(giftIds);
                if (result) {
                    dom.$id(btnIdBeforeRecv).style.display = 'none';
                    dom.$id(btnIdAfterRecv).style.display = 'flex';
                }
            }
        },
        handleBatchUseClick() {
            onBatchUseClick && onBatchUseClick();
        },
    };
    const component = createComponent(tpl, { data, style }, events);

    return component;
};

function changeCouponListABtnStatus(status) {
    const btn = dom.$id(btnIdBeforeRecv);
    if (btn) {
        if (status === 0) {
            //未领取
            dom.$id(btnIdBeforeRecv).style.display = 'flex';
            dom.$id(btnIdAfterRecv).style.display = 'none';
        }
        if (status === 1) {
            //已领取
            dom.$id(btnIdBeforeRecv).style.display = 'none';
            dom.$id(btnIdAfterRecv).style.display = 'flex';
        }
    }
}

CouponListA.changeCouponListABtnStatus = changeCouponListABtnStatus;
CouponListA.describe = describeCouponListA;

export default CouponListA;
